import axios, { AxiosPromise } from 'axios';

export const reportar = (mensagem: string): AxiosPromise<any> =>
  axios.post(`/api/problemas`, { mensagem });
